export function buildScheduleSlots(matches, tournament) {
  const step = ((tournament.match_duration || 20) + (tournament.break_time || 5)) * 60000;
  const times = matches.map((match) => new Date(match.scheduled_time).getTime())
    .filter((time, i) => matches[i].scheduled_time && Number.isFinite(time));
  const start = times.length ? Math.min(...times) : Date.now();
  const maxTime = times.length ? Math.max(...times) : start;
  const perField = Math.ceil(matches.length / Math.max(1, (tournament.fields || []).length));
  const count = Math.min(40, Math.max(perField + 2, Math.ceil((maxTime - start) / step) + 3));
  const regular = Array.from({ length: count }, (_, i) => start + i * step);
  // Always include exact manually selected times, even on another day or
  // outside the regular grid. Never snap a displayed match to a nearby time.
  return [...new Set([...regular, ...times])].sort((a, b) => a - b)
    .map((ms, index) => ({ index, ms, iso: new Date(ms).toISOString() }));
}
